/**
 * A simple condition that compares a single field against expected values.
 * @example
 * { operator: 'EQUAL', fieldName: 'status', fieldValues: ['active'] }
 * { operator: 'ANY_OF', fieldName: 'type', fieldValues: ['premium', 'enterprise'] }
 */

export const isSimpleCondition = condition => {
  return 'fieldName' in condition;
};

/**
 * A complex condition that combines multiple conditions using AND/OR logic.
 * Supports nested conditions for sophisticated rules.
 * @example
 * { operator: 'AND', conditions: [condition1, condition2] }
 * { operator: 'OR', conditions: [condition1, condition2, condition3] }
 */

export const isComplexCondition = condition => {
  return 'conditions' in condition;
};